import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './FeaturedProducts.css';
import { products } from '../../pages/Products/Product';

const FeaturedProducts = () => {
  const navigate = useNavigate();
  const productCardsRef = useRef([]);

  // Filter products by the specified IDs
  const featuredProductIds = [5, 9, 16, 21, 22, 23];
  const featuredProducts = products.filter(product => 
    featuredProductIds.includes(product.id)
  );

  useEffect(() => {
    const handleScroll = () => {
      productCardsRef.current.forEach((card, index) => {
        if (card) {
          const rect = card.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
          
          if (isInView) {
            setTimeout(() => {
              card.classList.add('featuredproducts__animate-in');
            }, index * 100);
          } else {
            card.classList.remove('featuredproducts__animate-in');
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };

 

  return (
    <div className="featuredproducts">
      <div className="featuredproducts__container">
        <div className="featuredproducts__header">
          <h2 className="featuredproducts__title">Featured Products</h2>
          <p className="featuredproducts__subtitle">
            Discover our most popular and trusted paint solutions
          </p>
        </div>

        <div className="featuredproducts__grid">
          {featuredProducts.map((product, index) => (
            <div
              key={product.id}
              className={`featuredproducts__card ${index % 2 === 0 ? 'featuredproducts__card--even' : 'featuredproducts__card--odd'}`}
              onClick={() => handleProductClick(product.id)}
              ref={(el) => (productCardsRef.current[index] = el)}
            >
              <div className="featuredproducts__image-wrapper">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="featuredproducts__image"
                />
                <div className="featuredproducts__overlay"></div>
              </div>
              <div className="featuredproducts__content">
                <h3 className="featuredproducts__name">{product.name}</h3>
                <div className="featuredproducts__text-wrapper">
                  <p className="featuredproducts__description">{product.description}</p>
                  <span className="featuredproducts__viewmore">
                    View More <span className="featuredproducts__arrow">→</span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProducts;
